import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_CURRATIVE_ORDER_LIST = 'FETCH_CURRATIVE_ORDER_LIST'
export const RECEIVE_CURRATIVE_ORDER_LIST = 'RECEIVE_CURRATIVE_ORDER_LIST'
export const FAILED_CURRATIVE_ORDER_LIST = 'FAILED_CURRATIVE_ORDER_LIST'

export const FETCH_CURRATIVE_ORDER_IMAGE_LIST = 'FETCH_CURRATIVE_ORDER_IMAGE_LIST'
export const RECEIVE_CURRATIVE_ORDER_IMAGE_LIST = 'RECEIVE_CURRATIVE_ORDER_IMAGE_LIST'
export const FAILED_CURRATIVE_ORDER_IMAGE_LIST = 'FAILED_CURRATIVE_ORDER_IMAGE_LIST'

export function fetchCurrativeOrder(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_CURRATIVE_ORDER_LIST});
        axios({
            method: 'post',
            url: API_LINKS.CURRATIVE_LIST,
            headers: {
                Authorization: auth
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_CURRATIVE_ORDER_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_LIST
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_CURRATIVE_ORDER_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_CURRATIVE_ORDER_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchCurrativeOrderImage(idCurrativeOrder){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_CURRATIVE_ORDER_IMAGE_LIST});
        axios({
            method: 'post',
            url: API_LINKS.CURRATIVE_IMAGE_LIST,
            headers: {
                Authorization: auth
            },
            data:{
                id_curative_maintenance_submit: idCurrativeOrder
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_CURRATIVE_ORDER_IMAGE_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_IMAGE_LIST
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_IMAGE_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_IMAGE_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_CURRATIVE_ORDER_IMAGE_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_CURRATIVE_ORDER_IMAGE_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_CURRATIVE_ORDER_IMAGE_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}